module.exports = __webpack_public_path__ + "img/talron-fold.529ad9c4.svg";